import classNames from "classnames";
import React from "react";
import { PIN_LENGTH } from "./PinInput";

interface Props {
  length: number;
}

const PinDots = (props: Props) => {
  const dots = new Array(PIN_LENGTH)
    .fill(null)
    .map((_, i) => <div key={i} className={classNames({ filled: i < props.length })} />);

  return <div className="PinDots">{dots}</div>;
};

export default React.memo(PinDots);
